import * as React from 'react';
import { SvgLoader } from '../Generic';
import { ButtonProps, Button } from '../Button';

export type LoaderButtonProps = Omit<ButtonProps, 'theme'> & {
    loading?: boolean;
    color?: ButtonProps['theme'];
};

export const LoaderButton: React.FC<LoaderButtonProps> = ({ children, color, loading = false, ...rest }) => (
    <Button {...rest} theme={color}>
        <SvgLoader inline loading={loading} size="small">
            {children}
        </SvgLoader>
    </Button>
);
LoaderButton.displayName = 'LoaderButton';
